/* Cartes produit retournables : bouton, inclinaison et reflet au survol (JS simple, sans dependance). */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function setFlip(box, on) {
    var btn = box.querySelector('[data-flip-btn]');
    var front = box.querySelector('[data-flip-front]');
    var back = box.querySelector('[data-flip-back]');
    box.classList.toggle('is-flipped', on);
    box.style.setProperty('--rx', '0deg');
    box.style.setProperty('--ry', '0deg');
    box.style.setProperty('--glare', '0');
    if (btn) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(on ? 'data-label-close' : 'data-label-open'));
    }
    if (front) { if (on) front.setAttribute('inert', ''); else front.removeAttribute('inert'); }
    if (back) {
      if (on) back.removeAttribute('inert'); else back.setAttribute('inert', '');
      back.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-flip-btn]');
    if (btn) {
      var box = btn.closest('.pp-card__media');
      var flip = box && box.querySelector('[data-flip]');
      if (flip) setFlip(flip, !flip.classList.contains('is-flipped'));
      return;
    }
    var back = e.target.closest('[data-flip-back]');
    if (back && !e.target.closest('a')) setFlip(back.closest('[data-flip]'), false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-flip].is-flipped').forEach(function (b) { setFlip(b, false); });
  });

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || !fine.matches || reduce.matches) return;
    var box = e.target.closest && e.target.closest('[data-flip]');
    if (!box || box.classList.contains('is-flipped')) return;
    var r = box.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width;
    var y = (e.clientY - r.top) / r.height;
    box.classList.add('is-tilting');
    box.style.setProperty('--ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
    box.style.setProperty('--rx', ((0.5 - y) * 12).toFixed(2) + 'deg');
    box.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
    box.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
    box.style.setProperty('--glare', '1');
  });

  document.addEventListener('pointerout', function (e) {
    var box = e.target.closest && e.target.closest('[data-flip]');
    if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
    box.classList.remove('is-tilting');
    box.style.setProperty('--rx', '0deg');
    box.style.setProperty('--ry', '0deg');
    box.style.setProperty('--glare', '0');
  });
})();
